export const ACCESS_TOKEN = 'Access-Token'
export const PARENT_URL = 'Parent-Url'
export const selectCartId = 'selectCartId'
